import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, inject, effect } from '@angular/core';
import {Subject} from 'rxjs';
import {filter, takeUntil, take} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {CdkConfigService} from '@cdk/services/config.service';
import {CdkSidebarService} from '@cdk/components/sidebar/sidebar.service';
import {navigation} from 'app/navigation/navigation';
import {Router} from '@angular/router';
import {LoginService} from 'app/main/auth/login/login.service';
import {NotificacaoService} from '@cdk/services/notificacao.service';
import {select, Store} from '@ngrx/store';
import * as fromStore from 'app/store';
import {
    ButtonTodasNotificacoesLidas,
    getCounterState,
    getMercureState, ReloadNotificacoes,
    RemoveAllNotificacao,
    RemoveNotificacao
} from 'app/store';
import {Logout} from '../../../main/auth/login/store';
import {Usuario} from '@cdk/models/usuario.model';
import {Notificacao} from '@cdk/models';
import {getIsLoading, getNotificacaoList, getOperacoesEmProcessamento} from '../../../store';
import {getChatIsLoading} from '../chat-panel/store';
import {ComponenteDigitalService} from '@cdk/services/componente-digital.service';
import {CdkConfirmDialogComponent} from '@cdk/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {DateTime} from 'luxon';
import { MatToolbar, MatIconButton, MatIcon, MatButton, MatMenuTrigger, MatMenu, MatMenuItem, MatTooltip, MatList, MatListItem, MatDivider, MatProgressSpinner, MatCheckbox } from '@cdk/angular/material';
import { DatePipe } from '@angular/common';
// ALTERADO PELA PGE-RS: retirado o ShowIfRoleDirective para evitar warning.
//import { ShowIfRoleDirective } from '@cdk/directives/show-if-role.directive';
import { BarraPesquisaComponent } from '@cdk/components/barra-pesquisa/barra-pesquisa.component';
import { MatBadge } from '@angular/material/badge';
import { ShepherdComponent } from '../../../../ajuda/tour/tour.component';
import { TitleCasePipe } from '@cdk/pipes/title-case.pipe';
import { SafeResourceUrlPipe } from '@cdk/pipes/safe-resource-url.pipe';
import {AjudaComponent} from '../../../../ajuda/ajuda.component';
import { OperacoesStore } from 'app/store/signals/operacoes.store';
import {format} from 'date-fns';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
        imports: [
        MatToolbar,
        MatIconButton,
        MatIcon,
        //ShowIfRoleDirective, // ALTERADO PELA PGE-RS: retirado o ShowIfRoleDirective para evitar warning.
        BarraPesquisaComponent,
        MatButton,
        MatMenuTrigger,
        MatMenu,
        MatMenuItem,
        MatTooltip,
        MatBadge,
        MatList,
        MatListItem,
        MatDivider,
        MatProgressSpinner,
        MatCheckbox,
        ShepherdComponent,
        DatePipe,
        TitleCasePipe,
        SafeResourceUrlPipe
    ],
    providers: [
        NotificacaoService,
        AjudaComponent
    ],
})

export class ToolbarComponent implements OnInit, OnDestroy {
    _cdkConfigService = inject(CdkConfigService);
    _cdkSidebarService = inject(CdkSidebarService);
    private _translateService = inject(TranslateService);
    _loginService = inject(LoginService);
    private _notificacaoService = inject(NotificacaoService);
    private _store = inject<Store<fromStore.State>>(Store);
    private _router = inject(Router);
    private _componenteDigitalService = inject(ComponenteDigitalService);
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _dialog = inject(MatDialog);

    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    userProfile: Usuario;
    notificacoes: Notificacao[] = [];
    notificacoesCount: string;
    carregandoNotificacao = true;
    carregadoNotificacao = false;
    notificacaoIniciaisCarregadas = false;
    carregandoChat: boolean = true;
    totalChatMensagensNaoLidas: any = 0;
    cdkConfig: any;
    checkedNotifications: Notificacao[] = [];

    titulo = 'processo';

    operacoesProcessando = 0;
    operacoesPendentes = 0;

    assinadores: any = [];
    assinadorTime: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    #operacoesStore = inject(OperacoesStore);


    /**
     * @param _cdkConfigService
     * @param _cdkSidebarService
     * @param _translateService
     * @param _loginService
     * @param _notificacaoService
     * @param _store
     * @param _router
     * @param _componenteDigitalService
     * @param _changeDetectorRef
     * @param _dialog
     */
    constructor() {
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            },
            {
                id: 'tr',
                title: 'Turkish',
                flag: 'tr'
            }
        ];

        this.userProfile = this._loginService.getUserProfile();

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.assinadores = [];
        localStorage.removeItem('assinador');

        effect(() => {
            const value = this.#operacoesStore.operacoesEmProcessamento();
            this.operacoesProcessando = Object.keys(value).length;
            if (this.operacoesProcessando === 0) {
                this.operacoesPendentes = 0;
            } else {
                if (this.operacoesProcessando > this.operacoesPendentes) {
                    this.operacoesPendentes = this.operacoesProcessando;
                }
            }
            this._changeDetectorRef.detectChanges();
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the config changes
        this._cdkConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                // Subscribe to config changes
                this.cdkConfig = settings;
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {id: this._translateService.currentLang});

        this._store
            .pipe(
                select(getNotificacaoList),
                takeUntil(this._unsubscribeAll),
            )
            .subscribe((notificacoes) => {
                if (notificacoes) {
                    this.notificacoes = notificacoes.sort(((n1,n2) => n2.id - n1.id));
                }
            });
        this._store
            .pipe(
                select(getIsLoading),
                takeUntil(this._unsubscribeAll),
            )
            .subscribe(carregandoNotificacao => this.carregandoNotificacao = carregandoNotificacao);
        this._store
            .pipe(
                select(fromStore.getNotificacaoListLoaded),
                takeUntil(this._unsubscribeAll),
            )
            .subscribe(carregadoNotificacao => {
                this.carregadoNotificacao = carregadoNotificacao
            });
        /* COMENTADO PELA PGE-RS, issue: https://gitlab01.pgers.intra.rs.gov.br/supp/supp-administrativo-frontend/-/issues/259
        this._store
            .pipe(
                select(getChatIsLoading),
                takeUntil(this._unsubscribeAll),
            ).subscribe(carregandoChat => this.carregandoChat = carregandoChat);
        */
        this._store
            .pipe(
                select(getCounterState),
                takeUntil(this._unsubscribeAll)
            ).subscribe((value) => {
                if (value && value['notificacoes_pendentes'] !== undefined) {
                    if (parseInt(value['notificacoes_pendentes'], 10) > 99) {
                        this.notificacoesCount = '99+';
                    } else {
                        this.notificacoesCount = value['notificacoes_pendentes'];
                    }
                }

                // COMENTADO PELA PGE-RS, issue: https://gitlab01.pgers.intra.rs.gov.br/supp/supp-administrativo-frontend/-/issues/259
                // if (value && value['chat_mensagens_nao_lidas'] !== undefined) {
                //     if (parseInt(value['chat_mensagens_nao_lidas'], 10) > 99) {
                //         this.totalChatMensagensNaoLidas = '99+';
                //     } else {
                //         this.totalChatMensagensNaoLidas = value['chat_mensagens_nao_lidas'];
                //     }
                // }
            }
        );

        this._loginService.getUserProfileChanges()
            .pipe(
                takeUntil(this._unsubscribeAll),
                filter(userProfile => !!userProfile)
            )
            .subscribe(userProfile => this.userProfile = userProfile);

        this._loginService.getUserChangedOtherTab().pipe(
            filter(changed => !!changed),
            takeUntil(this._unsubscribeAll)
        ).subscribe((loggedUserChanged) => {
                const dialogRef = this._dialog.open(CdkConfirmDialogComponent, {
                    data: {
                        title: 'Mudança de usuário logado detectada',
                        confirmLabel: 'Recarregar',
                        hideCancel: true,
                        message: 'Foi detectada a mudança do usuário autenticado em outra aba do navegador. O sistema precisa ser recarregado.'
                    },
                    disableClose: true
                });

                dialogRef.afterClosed().pipe(take(1)).subscribe((result) => {
                    if (result) {
                        window.location.reload();
                    }
                });
        });

        this._store.pipe(
            select(getMercureState),
            takeUntil(this._unsubscribeAll)
        ).subscribe((message) => {
            if (message && message.type === 'assinatura') {
                switch (message.content.action) {
                    case 'ALIVE':
                        const assinadorVersion = localStorage.getItem('assinadorVersion');
                        if (this.compareVersions(message.content.subscriberInfo.version, assinadorVersion)) {
                            this.assinadores = this.assinadores.filter(info => info.processUUID !== message.content.subscriberInfo.processUUID);
                            let selecionado = false;
                            if (this.assinadores.length === 0) {
                                selecionado = true;
                                localStorage.setItem('assinador', message.content.subscriberInfo.processUUID);
                            }
                            this.assinadores.push({
                                timestamp: DateTime.now().toUnixInteger(),
                                selecionado: selecionado,
                                ...message.content.subscriberInfo
                            });
                        }
                        break;
                    case 'DISCONNECTED_NOW':
                        this.assinadores = this.assinadores.filter(info => info.processUUID === message.content.processUUID);
                        if (this.assinadores.length > 0) {
                            let temSelecionado = false;
                            this.assinadores.forEach((ass) => {
                                if (ass.selecionado) {
                                    temSelecionado = true;
                                    localStorage.setItem('assinador', this.assinadores[0].processUUID);
                                }
                            });
                            if (!temSelecionado) {
                                this.assinadores[0].selecionado = true;
                                localStorage.setItem('assinador', this.assinadores[0].processUUID);
                            }
                        } else {
                            localStorage.removeItem('assinador');
                        }
                        break;
                }
            }
        });


        this.assinadorTime = setInterval(() => {
            const timestamp = DateTime.now().toUnixInteger();
            this.assinadores = this.assinadores.filter(info => (timestamp - info.timestamp) < 15);
            if (this.assinadores.length > 0) {
                let temSelecionado = false;
                this.assinadores.forEach((ass) => {
                    if (ass.selecionado) {
                        temSelecionado = true;
                        localStorage.setItem('assinador', this.assinadores[0].processUUID);
                    }
                });
                if (!temSelecionado) {
                    this.assinadores[0].selecionado = true;
                    localStorage.setItem('assinador', this.assinadores[0].processUUID);
                }
            } else {
                localStorage.removeItem('assinador');
            }
        }, 10000);
    }

    /**
     * Compara a versão do assinador com a versão do backend
     * @param suppVersion
     * @param requiredVersion
     * @return boolean
     */
    compareVersions(suppVersion: string, requiredVersion: string): boolean {
        const [suppMajor, suppMinor, suppRelease] = suppVersion.split('.').map(Number);
        const [requiredMajor, requiredMinor, requiredRelease] = requiredVersion.split('.').map(Number);

        if (suppMajor !== requiredMajor) {
            return false;
        }

        if (suppMinor > requiredMinor) {
            return true;
        }

        if (suppMinor === requiredMinor && suppRelease >= requiredRelease) {
            return true;
        }

        return false;
    }

    setAssinadorSelecionado(assinador): void {
        this.assinadores.forEach((ass) => {
            ass.selecionado = assinador.processUUID === ass.processUUID;
            if (ass.selecionado) {
                if (this.assinadores.length === 0) {
                    localStorage.setItem('assinador', ass.processUUID);
                }
            }
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
        clearInterval(this.assinadorTime);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        if (key === 'ajudaPanel') {
            if (!this._cdkSidebarService.getSidebar('quickPanel').isLockedOpen) {
                this._cdkSidebarService.getSidebar('quickPanel').close();
            } else {
                this._cdkSidebarService.getSidebar('quickPanel').fold();
            }
        }
        this._cdkSidebarService.getSidebar(key).toggleOpen();
    }

    toggleQuickPanel(): void {
        if (!this._cdkSidebarService.getSidebar('quickPanel').isLockedOpen) {
            this._cdkSidebarService.getSidebar('quickPanel').toggleOpen();
        } else {
            this._cdkSidebarService.getSidebar('quickPanel').toggleFold();
        }
    }

    // COMENTADO PELA PGE-RS, issue: https://gitlab01.pgers.intra.rs.gov.br/supp/supp-administrativo-frontend/-/issues/259
    // toggleChatPanel(): void {
    //     if (!this._cdkSidebarService.getSidebar('chatPanel').isLockedOpen) {
    //         this._cdkSidebarService.getSidebar('chatPanel').toggleOpen();
    //     } else {
    //         this._cdkSidebarService.getSidebar('chatPanel').toggleFold();
    //     }
    // }

    /**
     * Search
     *
     * @param emissao
     */
    search(emissao): void {
        const chaveAcesso = emissao.chaveAcesso ? '/' + emissao.chaveAcesso : '';
        this._router.navigate(['apps/processo/' + emissao.id  + '/chave/' + chaveAcesso + '/visualizar']);
    }

    goConfiguracoes(): void {
        this._router.navigate(['apps/configuracoes/perfil']);
    }

    goNotificacoes(): void {
        this._router.navigate(['apps/configuracoes/notificacoes']);
    }

    goLogout(): void {
        this._store.dispatch(new Logout({url: false}));
    }

    tour(tour: string): void {
        this.titulo = tour;
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }

    toggleLida(notificacao: Notificacao): void {
        this._store.dispatch(new fromStore.ToggleLidaNotificacao(notificacao));
    }

    getNotificacaoContext(notificacao: Notificacao): any
    {
        return notificacao.contexto ? JSON.parse(notificacao.contexto) : false;
    }

    sendToTarget(notificacao: Notificacao): any {
        const contexto = this.getNotificacaoContext(notificacao);
        switch (notificacao.tipoNotificacao.nome) {
            case 'RELATORIO':
                return this._router
                    .navigate([
                        `/apps/relatorios/administrativo/meus-relatorios/entrada/relatorio/${contexto.id}/visualizar`
                    ]);
            case 'PROCESSO':
            case 'DOWNLOAD PROCESSO':
                return this._router.navigate([`/apps/processo/${contexto.id}/visualizar/latest`]);
            case 'TAREFA':
                return this._router
                    .navigate([
                    `/apps/tarefas/administrativo/minhas-tarefas/entrada/tarefa/${contexto.id}/processo/${contexto.id_processo}/visualizar/latest`
                ]);
            default:
                return;
        }
    }

    openNewTab(notificacao: Notificacao): any {
        const contexto = this.getNotificacaoContext(notificacao);
        switch (notificacao.tipoNotificacao.nome) {
            case 'RELATORIO':
                return window.open(`/apps/relatorios/administrativo/meus-relatorios/entrada/relatorio/${contexto.id}/visualizar`);
            case 'PROCESSO':
            case 'DOWNLOAD PROCESSO':
                return window.open(`/apps/processo/${contexto.id}/visualizar/latest`);
            case 'TAREFA':
                return window.open(
                        `/apps/tarefas/administrativo/minhas-tarefas/entrada/tarefa/${contexto.id}/processo/${contexto.id_processo}/visualizar/latest`
                );
            default:
                return;
        }
    }

    // Download direto: navegador gerencia a transferencia.
    // ATERADO PELA PGE-RS: https://gitlab01.pgers.intra.rs.gov.br/supp/supp-administrativo-backend/-/issues/184
    downloadDireto(notificacao: Notificacao): void
    {
        const contexto = this.getNotificacaoContext(notificacao);
        if (contexto?.componente_digital_id) {
            const link = document.createElement('a');
            link.href = this._componenteDigitalService.getDownloadDiretoUrl(contexto.componente_digital_id);
            document.body.appendChild(link);
            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            link.remove();
        }
    }

    download(notificacao: Notificacao): void
    {
        const contexto = this.getNotificacaoContext(notificacao);
        if (contexto?.componente_digital_id) {
            this._componenteDigitalService
                .downloadBinary(contexto.componente_digital_id)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe((response) => {
                    if (response?.body) {
                        const URL = window.URL;
                        const data = URL.createObjectURL(response.body);

                        const link = document.createElement('a');
                        link.href = data;
                        link.download = this.getFileNameFromContentDisposition(
                            response.headers.get('Content-Disposition')
                        );
                        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

                        setTimeout( () => {
                            window.URL.revokeObjectURL(data);
                            link.remove();
                        }, 100);
                    }
                });
        }
    }

    // ATERADO PELA PGE-RS: https://gitlab01.pgers.intra.rs.gov.br/supp/supp-administrativo-backend/-/issues/184
    private getFileNameFromContentDisposition(contentDisposition: string | null): string
    {
        if (!contentDisposition) {
            return 'download';
        }

        const encodedFileName = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (encodedFileName?.[1]) {
            return decodeURIComponent(encodedFileName[1].replace(/"/g, ''));
        }

        const fileName = contentDisposition.match(/filename="?([^"]+)"?/i);
        return fileName?.[1] ?? 'download';
    }

    marcarTodasComoLida(): void {
        this._store.dispatch(new ButtonTodasNotificacoesLidas());
    }

    excluirTodasNotificaoes(): void {
        this._store.dispatch(new RemoveAllNotificacao());
    }

    removerNotificacao(notificacao): void {
        this._store.dispatch(new RemoveNotificacao(notificacao.id));
    }

    marcarSelecionadosComoLido(): void {
        this.checkedNotifications.forEach((notificacao) => {
            if (!notificacao.dataHoraLeitura) {
                this.toggleLida(notificacao);
            }
        });

        this.resetSelecoes();
    }

    removerSelecionados(): void {
        this.checkedNotifications.forEach((notificacao) => {
            this._store.dispatch(new RemoveNotificacao(notificacao.id));
        });

        this.resetSelecoes();
    }

    resetSelecoes(): void {
        this.checkedNotifications = [];
    }

    /**
     * @param checked
     * @param notification
     */
    checkNotification(checked: boolean, notification: Notificacao): any {
        if (checked) {
            return this.checkedNotifications.push(notification);
        }

        this.checkedNotifications = this.checkedNotifications.filter(item => item.id !== notification.id);
    }

    reload() {
        this._store.dispatch(new ReloadNotificacoes());
    }

    loadNotificacoes() {
        if(!this.notificacaoIniciaisCarregadas) {
            this.notificacaoIniciaisCarregadas = true;
            const params = {
                filter: {
                    'destinatario.id': 'eq:' + this._loginService.getUserProfile().id,
                    'dataHoraExpiracao': 'gt:' + format(new Date(), 'yyyy-MM-dd\'T\'HH:mm:ss')
                },
                gridFilter: {},
                limit: 10,
                offset: 0,
                sort: {id: 'DESC'},
                populate: ['tipoNotificacao']
            };
            this._store.dispatch(new fromStore.GetNotificacoes(params));
        }
    }
}
